import CopilotChatThread from './CopilotChatThread';
import React from 'react';
import styled from 'styled-components';
import { parse } from 'date-fns';
import { groupItemsByCreatedAt } from '../utils/GroupingUtils';
import { ChatRead } from '../../../store/generated/portal/chat/copilot';

type CopilotThreadListProps = {
  chatHistory?: ChatRead[] | null;
  selectedThreadId: number;
  setSelectedThreadId: (threadId: number) => void;
  onThreadDeleted: (threadId: number) => void;
};

const DaySection = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 16px;
  opacity: 100;
`;

const DaysAgo = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  text-transform: capitalize;
  line-height: 140%;
  color: #666d79;
`;

const CopilotThreadList = (props: CopilotThreadListProps) => {
  const { chatHistory, selectedThreadId, setSelectedThreadId } = props;

  const groupedHistory = groupItemsByCreatedAt<ChatRead>(chatHistory || []);

  const sortedGroups = Object.entries(groupedHistory)
    .filter(([, items]) => items.length !== 0)
    .sort(([labelA], [labelB]) => {
      const fixedOrder: Record<string, number> = {
        today: 0,
        'last 7 days': 1,
        'last month': 2,
      };

      const isFixedA = labelA in fixedOrder;
      const isFixedB = labelB in fixedOrder;

      if (isFixedA && isFixedB) {
        return fixedOrder[labelA] - fixedOrder[labelB];
      }
      if (isFixedA) {
        return -1;
      }
      if (isFixedB) {
        return 1;
      }

      const dateA = parse(labelA, 'MMMM yyyy', new Date()).getTime();
      const dateB = parse(labelB, 'MMMM yyyy', new Date()).getTime();
      return dateB - dateA;
    });

  return sortedGroups.map(([timeAgo, items], index: number) => (
    <DaySection key={index}>
      <DaysAgo>{timeAgo}</DaysAgo>
      {
        items.map((chat: ChatRead, nestedIndex: number) => (
          <CopilotChatThread
            key={nestedIndex}
            threadId={chat.id}
            selectedThreadId={selectedThreadId}
            threadName={chat.name}
            onClick={setSelectedThreadId}
            onThreadDeleted={props.onThreadDeleted}
          />
        ))
      }
    </DaySection>
  ));
};

export default CopilotThreadList;
